import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class VerticalLayoutVerticalAlign extends BaseOption {
  static userInterfaceComponent = {
    label: "Vertical Align",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          icon: "position-top",
          value: "top",
        },
        {
          icon: "position-middle-vertical",
          value: "middle",
        },
        {
          icon: "position-bottom",
          value: "bottom",
        },
        {
          icon: "position-between-vertical",
          value: "between",
        },
        {
          icon: "position-around-vertical",
          value: "around",
        },
        {
          icon: "position-evenly-vertical",
          value: "evenly",
        },
      ],
    },
  };

  static defaultValue = "top";

  static convertConfigValueToCompiledValue(configValue) {
    if (typeof configValue === "string") {
      return configValue;
    }
    if (configValue && configValue.value) {
      return configValue.value;
    }
  }
}
